/**
 * Hair Quiz Newsletter - Handle URL parameters and navigation
 * @description Manages URL parameters for quiz data, results navigation, and SKU prefetch
 */

(function () {
  'use strict';

  // Configuration
  const RESULTS_PAGE = '/pages/hair-quiz-results';

  /**
   * Populate quiz-data element with URL parameters
   * @param {Object} params - Object containing handles and tags arrays
   */
  function populateQuizDataFromUrl(params) {
    const quizDataEl = document.getElementById('quiz-data');
    if (!quizDataEl) {
      return;
    }

    quizDataEl.setAttribute('data-handles', params.handles.join(','));
    quizDataEl.setAttribute('data-tags', params.tags.join(','));
  }

  /**
   * Update "See my personalized routine" link with URL parameters
   * @param {Object} params - Object containing handles and tags arrays
   */
  function updateResultsLink(params) {
    const resultsLink = document.getElementById('see-results-link');
    if (!resultsLink) {
      return;
    }

    const urlParams = new URLSearchParams();

    if (params.handles.length > 0) {
      urlParams.set('handles', params.handles.join(','));
    }
    if (params.tags.length > 0) {
      urlParams.set('tags', params.tags.join(','));
    }

    if (urlParams.toString()) {
      resultsLink.href = `${RESULTS_PAGE}?${urlParams.toString()}`;
    }

    resultsLink.classList.remove('dav-hair-quiz-newsletter__nav-button--disabled');
    resultsLink.removeAttribute('aria-disabled');
  }

  /**
   * Initialize newsletter page
   */
  async function init() {
    // Wait for DOM to be fully loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
      return;
    }

    // Get URL parameters from utils
    const params = window.hairQuizUtils.getUrlParams();

    // Fetch products and save SKU-category mapping for middleware
    if (params.handles.length > 0) {
      const products = await window.hairQuizUtils.fetchProducts(params.handles);
      window.hairQuizUtils.saveSkuToCategoryMap(products);
      window.hairQuizProducts = products;
    }

    // Populate quiz data from URL parameters
    populateQuizDataFromUrl(params);

    // Update results link with URL parameters
    updateResultsLink(params);
  }

  // Initialize
  init();
})();
